import React from "react";
import DocxIcon from "../../common/Components/Icons/DocxIcon";
import ReactPlayer from "react-player/file";
import CircleLoader from "../../common/Components/Loader/CircleLoader";
import { HKPImage } from "../../media/HKPImage";
import { retryProductMedia } from "../../uploads/productMediaUploadManager";
import {
  isPreviewDoc,
  isPreviewImage,
  isPreviewVideo,
  previewMediaUrl,
} from "./previewMedia";

const FilePreviewPart = (props: any) => {
  const { item, handleOpen, handleSetImage } = props;
  const src = previewMediaUrl(item);
  const isWordDoc =
    item?.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    item?.type === "application/msword";
  const uploadStatus = item?.uploadStatus;
  const uploadBusy = uploadStatus === "QUEUED" || uploadStatus === "UPLOADING";
  const uploadFailed = uploadStatus === "FAILED";

  if (uploadBusy || uploadFailed) {
    return (
      <div className="preview-media-cell">
        <div className="preview-media-thumb preview-media-thumb--busy">
          {uploadBusy ? <CircleLoader /> : null}
          <div className="hkp-media-grid__upload-label">
            {uploadFailed
              ? item?.uploadError || "Upload failed · Retry"
              : uploadStatus === "QUEUED"
                ? "Queued"
                : `Uploading ${Number(item?.uploadProgress || 0)}%`}
          </div>
          {uploadFailed && item?.mediaId ? (
            <button
              type="button"
              className="hkp-media-grid__retry"
              onClick={() => retryProductMedia(item.mediaId)}
            >
              Retry
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div
      className="preview-media-cell"
      onClick={() => {
        handleOpen?.();
        handleSetImage?.(item);
      }}
    >
      {isWordDoc && (
        <div className="preview">
          <DocxIcon />
          <div className="d-block">
            <p>{item?.fileName}</p>
          </div>
        </div>
      )}

      {!isWordDoc && isPreviewImage(item) && (
        <div className="preview-media-thumb">
          <HKPImage
            preset="PRODUCT_CARD"
            localPreviewUrl={String(src || "").startsWith("blob:") ? src : undefined}
            mediaId={item?.mediaAssetId || undefined}
            legacyUrl={src}
            alt=""
          />
        </div>
      )}
      {!isWordDoc && isPreviewVideo(item) && (
        <div className="preview-media-thumb preview-media-thumb--video">
          <ReactPlayer
            className="preview-media-player"
            playing={false}
            controls={true}
            url={src}
            muted={true}
            width="100%"
            height="100%"
            config={{
              attributes: {
                playsInline: true,
                style: {
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  objectPosition: "center",
                },
              },
            }}
          />
        </div>
      )}
      {!isWordDoc && isPreviewDoc(item) && (
        <div className="preview-media-thumb">
          <iframe title={item?.name || "document"} src={src} />
        </div>
      )}
      {item?.source === "FIELD_LINK" || item?.lat != null ? (
        <div className="text-muted small mt-1">
          Field capture
          {item?.lat != null && item?.lng != null
            ? ` · ${Number(item.lat).toFixed(4)}, ${Number(item.lng).toFixed(4)}`
            : ""}
        </div>
      ) : null}
    </div>
  );
};

export default FilePreviewPart;
